export const locales = ['en', 'es'];
